import InputFileSize from './InputFileSize'
import Octets from './Octets'
import Bytes from './Bytes'
import Durations from './Durations'
import MonitoringPercent from './MonitoringPercent'
import DateFilter from './Date'
import Number from './Number'

export default [
  {name: 'InputFileSize', fn: InputFileSize},
  {name: 'Octets', fn: Octets},
  {name: 'Bytes', fn: Bytes},
  {name: 'Durations', fn: Durations},
  {name: 'MonitoringPercent', fn: MonitoringPercent},
  {name: 'Date', fn: DateFilter},
  {name: 'Number', fn: Number}
]
